<div class="card-grid" *ngIf="display === 'grid'" #grid>
  <div *ngFor="let entry of entries" class="card-grid-item">
    <uni-publication-card
      [publication]="entry.publication"
      [host]="host"
      [publicationType]="publicationType"
      [self]="self"
      [featured]="featured"
      [hasImageBadge]="hasImageBadge"
      [hasImageFooter]="hasImageFooter"
      [footerType]="footerType"
      [showTimestamp]="showTimestamp">
    </uni-publication-card>
  </div>
</div>
